define(
    '../../widgets/select-button/main',[
        'jquery',
        'utils/bind-manager'
    ],
    function ($, bindMng) {
        return function () {
            $(".select-button").find("button").text( $(".select-button select").find("option:first").text() );
            $(".select-button").find("button").attr( "data-do", $(".select-button select").find(":selected").val() );

            bindMng.add('.select-button select', 'focus', function () {
                $(this).parent().addClass('select--focused');
            });

            bindMng.add('.select-button select', 'blur', function () {
                $(this).parent().removeClass('select--focused');
            });

            bindMng.add('.select-button select', 'change', function () {
                $(this).parent().find("button").text( $(this).find(":selected").text() );
                $(this).parent().find("button").data( "do", $(this).find(":selected").val() );
            });
        };
    }
);
